export class DateModel {
  public constructor(
    public uuid?: string,
    public date?: string
  ) {}
}
